import async from 'async'
import * as sysOrgApi from '../api/sys/sysOrg'

export function ORG_NAME (data, okey, nkey, cb) {
  if (data != null) {
    if (data instanceof Array) {
      let vs = {}
      async.each(data, function (item, callback) {
        if (item[okey]) {
          sysOrgApi.get({'org_id': item[okey]}).then(rr => {
            vs[item[okey]] = rr.data.org_name
            callback(null)
          }).catch(rr => {
            callback(null)
          })
        }
      }, function () {
        for (let i = 0; i < data.length; i++) {
          data[i][nkey] = vs[data[i][okey]] ? vs[data[i][okey]] : ''
        }
        cb(data)
      })
    } else {
      if (data[okey]) {
        sysOrgApi.get({'org_id': data[okey]}).then(rr => {
          data[nkey] = rr.org_name
          cb(data)
        }).catch(rr => {
          data[nkey] = ''
          cb(data)
        })
      } else {
        cb(data)
      }
    }
  } else {
    cb(data)
  }
}
